export default __webpack_public_path__ + "static/media/the_moon.94af2a7a.png";